import axios from "axios";

export function getAuthApiError(e: unknown, fallback: string): string {
  if (axios.isAxiosError(e)) {
    const status = e.response?.status;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = e.response?.data as any;
    const message: string | undefined = Array.isArray(data?.message)
      ? data.message[0]
      : data?.message;

    if (status === 409) {
      return message || "Этот способ входа уже привязан к другому аккаунту";
    }
    if (status === 429) return "Слишком много попыток. Попробуйте позже.";
    if (status === 401) return "Неверный код";
    if (status === 410) return "Код устарел. Запросите новый.";
    if (message) return message;
  }
  return fallback;
}
